import { useMutation } from '@tanstack/react-query'
import { Modal, message } from 'antd'
import { BarcodeScanner } from 'react-barcode-scanner'
import { useNavigate } from 'react-router'
import 'react-barcode-scanner/polyfill'
import { API, COMMONS, MEMBER_UTILS } from '@/utils'
import { useScanErrorHandler } from '@/hooks/useScanErrorHandler'
import { useCheckinSound } from '@/hooks/useCheckinSound'

const CameraScanModal = (props: {
	isMemberVisit?: any
	isMemberRenewCameraModalVisible?: any
	hideMemberRenewDeviceModal?: any
	hideMemberRenewCameraModal?: any
	showMemberRenewConfirmModal?: any
}) => {
	const {
		isMemberRenewCameraModalVisible,
		hideMemberRenewCameraModal,
		showMemberRenewConfirmModal,
		isMemberVisit,
	} = props

	const navigate = useNavigate()
	const { handleScanError } = useScanErrorHandler()
	const { playSuccessSound, playAlreadyCheckedInSound } = useCheckinSound()

	const memberCheckMutation = useMutation({
		mutationFn: (data: any) => API.ADMIN_CHECK_MEMBER(data),
		onSuccess: (response: any) => {
			const data = response?.data

			if (!data) {
				message.warning(COMMONS.WARN_MEMBER_CODE_NOT_EXIST_MSG)
				return
			}

			const { pointsAwarded } = data || {}

			if (pointsAwarded) {
				playSuccessSound() // Per 2026/02/04 spec: sound on successful check-in
				message.success('チェックイン完了')
			} else {
				playAlreadyCheckedInSound()
				message.info('本日の来館は記録済みです')
			}

			showMemberRenewConfirmModal(data || {})
		},
		onError: handleScanError,
	})

	const memberSearchMutation = useMutation({
		mutationFn: (data: any) => API.ADMIN_GET_MEMBER_BY_CODE(data),
		onSuccess: (response: any) => {
			if (response?.data) {
				showMemberRenewConfirmModal(response.data)
				hideMemberRenewCameraModal()
			} else {
				message.warning(COMMONS.WARN_MEMBER_CODE_NOT_EXIST_MSG)
			}
		},
		onError: (error: any) => {
			if (error?.response?.status === COMMONS.RESPONSE_PERMISSION_ERROR) {
				navigate(COMMONS.PERMISSION_ERROR_ROUTE)
			} else if (error?.response?.status === COMMONS.RESPONSE_SESSION_ERROR) {
				message.warning(COMMONS.ERROR_SESSION_MSG)
				navigate(COMMONS.ADMIN_LOGIN_ROUTE)
			} else if (error?.response?.status === 404) {
				message.warning(COMMONS.WARN_MEMBER_CODE_NOT_EXIST_MSG)
			} else if (error?.response?.status === COMMONS.RESPONSE_SYSTEM_ERROR) {
				message.error(COMMONS.ERROR_SYSTEM_MSG)
			} else {
				message.error(COMMONS.ERROR_SYSTEM_MSG)
			}
		},
	})

	const handleMemberCheck = (data: any) => {
		const normalizedMemberCode = MEMBER_UTILS.normalizeMemberCode(data.memberCode)
		if (isMemberVisit) {
			const paramData = {
				memberCode: normalizedMemberCode,
				isMemberVisit: isMemberVisit,
			}
			memberCheckMutation.mutate(paramData)
		} else {
			memberSearchMutation.mutate({ memberCode: normalizedMemberCode })
		}
	}
	return (
		<>
			<Modal
				title={`${isMemberVisit ? '来店記録' : '会員更新'}・カメラ`}
				open={isMemberRenewCameraModalVisible}
				onCancel={hideMemberRenewCameraModal}
				footer={null}
				destroyOnClose
				centered
				styles={{
					body: {
						maxHeight: '80vh',
						overflowY: 'auto',
						overflowX: 'hidden',
					},
				}}
			>
				<div className='barcode-wrapper'>
					<div className='barcode-image-wrapper'>
						<BarcodeScanner
							options={{ formats: ['code_128', 'itf'], delay: 500 }}
							onCapture={(barcode) => {
								if (barcode) {
									handleMemberCheck({ memberCode: barcode?.rawValue })
									hideMemberRenewCameraModal()
								}
							}}
							trackConstraints={{
								width: { min: 640, ideal: 1280 },
								height: { min: 480, ideal: 480 },
							}}
						/>
					</div>
				</div>
			</Modal>
		</>
	)
}

export default CameraScanModal
